module.exports = __webpack_public_path__ + "static/img/forests06.f4b35e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests06.jpg
// module id = yQXF
// module chunks = 0